<template>
  <print v-if="isPrint" :form="form" :board="board" :projectId="projectId" :boardId="boardId" :postId="postId" :tbmStatus="tbmStatus" />
  <div v-else>
    <!--상단 현재 상태를 표시한다-->
    <div class="overflow-x-auto">
      <status-step :steps="steps" :status="statusNumber" :width="'100%'" />
    </div>

    <!-- TBM 여부 : 모바일 화면에서만 보임 -->
    <div class="mt-2 flex xl:hidden items-center gap-2" style="font-weight: 500" v-html="`TBM 여부 :  ${htmlComponent[tbmStatus]}`" @click="onClickTBM" />

    <!-- 허가 신청자 -->
    <field-select-module class="mt-28px" title="허가 신청자" v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!--    작업 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업 정보</h5>
    </div>

    <!--    작업허가 -->
    <work-permit
      class="mt-4"
      v-model="form.작업허가"
      :companyId="parseInt(form.작업정보.업체명.id)"
      :board="board"
      :readonly="board.readonly"
      :is-safety-manager="isSafetyManager"
      :is-print="isPrint"
      :tbmStatus="tbmStatus"
      :funcSelectOption="onSelectWorkPermit"
      @changeDate="findBusyUserList"
    />

    <div class="mt-4">
      <div class="writeGridContainer">
        <div class="writeGridCol2">
          <div>업체명</div>
          <p v-if="isPrint" class="print-input">{{ form.작업정보.업체명.com_name }}</p>
          <company-selector v-else class="w-full" v-model="form.작업정보.업체명.id" :company-name="form.작업정보.업체명.com_name" :readonly="board.readonly" @select="(company) => (form.작업정보.업체명 = company)" />
        </div>
        <div class="writeGridCol2">
          <div>작업장소</div>
          <div class="flex w-full">
            <region-selector v-model="form.작업정보.작업구역" />
          </div>
        </div>
        <div class="writeGridCol2">
          <div>작업내용</div>
          <ml-input v-model="form.작업정보.작업내용" :readonly="board.readonly" class="w-full" />
        </div>
      </div>
    </div>

    <!--    CCTV 정보-->
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> CCTV 정보</h5>
      <div class="writeGridContainer">
        <div v-for="(cctv, index) in form.CCTVs" class="writeGridCol2">
          <div>CCTV {{ index + 1 }}</div>
          <ml-input v-model="form.CCTVs[index].이름" :readonly="board.readonly" class="w-full" />
        </div>
      </div>
    </div>

    <!--    안전관계자(승인권자)-->
    <div class="mt-28px">
      <div class="flex flex-wrap justify-between items-center">
        <h5 class="mb-4"><i class="dot"></i> 안전관계자(승인권자)</h5>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>동국제강</div>
          <p v-if="isPrint" class="print-input">{{ safetyManagerDongkook.name }}</p>
          <member-selector v-else class="w-full" popup-type="user" v-model="safetyManagerDongkook.id" :member-name="safetyManagerDongkook.name" @select="(member) => onSelectMember(safetyManagerDongkook, member)" />
        </div>
        <div>
          <div>전화번호</div>
          <p v-if="isPrint" class="print-input">{{ safetyManagerDongkook.phone }}</p>
          <ml-input v-else class="w-full" readonly :value="formatPhone(safetyManagerDongkook.phone)" />
        </div>
      </div>

      <div class="writeGridContainer">
        <div>
          <div>확인자(안전환경팀, 필요시)</div>
          <p v-if="isPrint" class="print-input">{{ form.안전관계자.확인자유무 }}</p>
          <div v-else class="w-full flex-1 flex gap-x-8 gap-y-4">
            <radio-group
              v-model="form.안전관계자.확인자유무"
              flex
              :readonly="board.readonly || !isSafetyManager || form.안전관계자.확인자읽기전용"
              :items="[
                { label: 'Y', value: 'y' },
                { label: 'N', value: 'n' },
              ]"
              @input="onChangeSafetyManagerConfirmer"
            />

            <div v-if="form.안전관계자.확인자유무 === 'y'" class="grid md:flex items-center gap-x-4">
              <p style="font-weight: 700">
                허가자:<span class="ml-1" style="font-weight: 400"> {{ form.안전관계자.확인자.부서 }} {{ form.안전관계자.확인자.직책 }} {{ form.안전관계자.확인자.성명 || form.안전관계자.확인자.name }}</span>
              </p>
              <p style="margin-top: 4px; font-weight: 700">
                허가일시 :<span class="ml-1" style="font-weight: 400"> {{ new Date(form.안전관계자.확인일시).format("yyyy-MM-dd, HH:mm") }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 작업유형 -->
    <work-table981 v-model="form.inspectList" :readonly="board.readonly" :status="statusNumber" :is-print="isPrint" :board="board" @checkedTitle="checkedTitle" />

    <!--작업자 내역-->
    <worker-list981 ref="workerList" v-model="form.작업자내역" :is-print="isPrint" :qr-list="qrList" :use-confined-space-work="useConfinedSpaceWork" :refreshQrList="refreshQrList" @select="findBusyUserList" />

    <div class="mt-4">
      <div class="flex gap-4" style="align-items: center">
        <div class="whitespace-no-wrap" style="font-weight: 500; font-size: 14px">DKS 발주부서장 확인서</div>
        <file-uploader v-model="form.DKS발주부서장확인서" :readonly="board.readonly" class="w-full" />
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList" :is-print="isPrint" :readonly="board.readonly || !isSafetyManager" section-title="작업 전 사진" placeholder="00센터 신축현장 점검" />
    <PhotoUploadGridModule :row-count="2" :grid-count="2" v-model="form.photoList2" :is-print="isPrint" :readonly="board.readonly || !isSafetyManager" section-title="작업 후 사진" placeholder="00센터 신축현장 점검" />

    <!-- 파일첨부 -->
    <file-upload-module subTitle="※ 일반보수 : 작업계획서(중량물, 전기작업) 등" :custom-title="false" id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import { formatPhone } from "@/util/DataUtil";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";
import PopupLoadPrevBoard from "@/popup/PopupLoadPrevBoard.vue";
import SignField from "@/components/SignField.vue";
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import TableInspectMerge from "@/components/TableInspectMerge.vue";
import * as inspectData from "./inspectData";
import StatusStep from "@/components/StatusStep.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";
import MemberSelector from "@/components/selector/MemberSelector.vue";
import WorkPermit from "@/components/work-permit/WorkPermit.vue";
import Print from "./Print.vue";
import RegionSelector from "@/components/selector/RegionSelector.vue";
import WorkerList976 from "@/views/boards/single-page/976/WorkerList976.vue";
import RadioGroup from "@/components/radio/RadioGroup.vue";
import FileUploader from "@/components/FileUploader.vue";
import HttpRequest from "@/util/HttpRequest";
import { 직위옵션 } from "@/views/boards/single-page/976/selectOptions";
import WorkTable981 from "@/views/boards/single-page/981/WorkTable981.vue";
import WorkerList981 from "@/views/boards/single-page/981/WorkerList981.vue";

export default {
  components: {
    WorkerList981,
    RadioGroup,
    WorkerList976,
    RegionSelector,
    Print,
    WorkPermit,
    MemberSelector,
    CompanySelector,
    StatusStep,
    WorkTable981,
    TableInspectMerge,
    TableCustom,
    TimeSelector,
    SignField,
    PopupLoadPrevBoard,
    DateSelector,
    WriteGridContainer,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    header: Object,
    post: Object, // 게시글 전체 정보
  },
  computed: {
    myInfo() {
      return {
        company_id: 0, // userInfo 를 가져오기전 임의로 사용하기 위해 설정
        ...this.$store.state.auth.userInfo,
      };
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    qrList() {
      return this.post.qr_reads;
    },
    statusNumber() {
      const workStart = this.form.작업허가 && this.form.작업허가.작업승인 ? this.form.작업허가.작업승인.상태 === "승인" : "";
      const workEnd = this.form.작업허가 && this.form.작업허가.작업종료 ? this.form.작업허가.작업종료.상태 === "승인" : "";

      if (workEnd) return this.steps.indexOf("작업완료");
      if (workStart) return this.steps.indexOf("작업중");
      return this.steps.indexOf("등록");
    },
    isMobile() {
      return this.$viewport.isMobile;
    },
    showSpecialAttachment() {
      // 65세 혹은 외국인 작업자가 있는 경우
      for (let i = 0; i < this.form.작업자내역.length; i++) {
        if (this.isSeniorCitizen(this.form.작업자내역[i].생년월일) || this.form.작업자내역[i].is_foreigner === "외국인") {
          return true;
        }
      }
      return false;
    },
    htmlComponent() {
      const 미진행 = `<span class="flex items-center" style="color:#EA5455;"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#FFDADA"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M9.8002 5.8C9.8002 5.35817 9.44202 5 9.0002 5C8.55837 5 8.2002 5.35817 8.2002 5.8V9C8.2002 9.44183 8.55837 9.8 9.0002 9.8C9.44202 9.8 9.8002 9.44183 9.8002 9V5.8ZM8.99622 11.4C8.55659 11.4 8.2002 11.7582 8.2002 12.2C8.2002 12.6418 8.55659 13 8.99622 13H9.00418C9.44381 13 9.8002 12.6418 9.8002 12.2C9.8002 11.7582 9.44381 11.4 9.00418 11.4H8.99622Z" fill="#EA5455"/>
</svg> 미진행
</span>`;
      const 완료 = `<span class="flex items-center" style="color:#28C76F;"><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 17C13.4183 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 4.58172 17 9 17Z" fill="#CAF9DF"/>
<path d="M13.6436 5.95214C13.5413 5.85511 13.4039 5.80078 13.2607 5.80078C13.1175 5.80078 12.98 5.85511 12.8778 5.95214L7.95419 10.824L5.98471 8.8117C5.93769 8.75101 5.87776 8.7008 5.80895 8.66448C5.74013 8.62817 5.66408 8.60658 5.5859 8.6012C5.50772 8.59582 5.42921 8.60676 5.35578 8.63329C5.28235 8.65982 5.21567 8.70133 5.16024 8.75498C5.10482 8.80863 5.06197 8.87317 5.03456 8.94425C5.00716 9.01533 4.99582 9.09126 5.00137 9.16694C5.00693 9.24262 5.02924 9.31627 5.06675 9.38288C5.10427 9.44949 5.15617 9.50753 5.21888 9.55305L7.6259 11.989C7.6259 12.0949 7.84478 12.2008 7.95419 12.2008C8.03912 12.2008 8.12285 12.1816 8.19881 12.1449C8.27477 12.1081 8.34085 12.0547 8.39181 11.989L13.6436 6.69352C13.7438 6.59453 13.8 6.46144 13.8 6.32283C13.8 6.18422 13.7438 6.05113 13.6436 5.95214Z" fill="#28C76F"/>
</svg> 완료
</span>`;
      return {
        미진행,
        완료,
      };
    },
    // tbm 진행 상태
    // 830번 List.js 와 동일하게 처리해야 함.
    tbmStatus() {
      if (this.tbmList && this.tbmList.length > 0) {
        const body = JSON.parse(this.tbmList[0].post_content).body;
        const 참석자명단 = body.참석자명단;
        const 사진대지 = body.photoList.filter((e) => e.id);
        const TBM실시시간 = body.TBM정보.TBM실시시간;

        if (참석자명단.length > 0 && 사진대지.length > 0 && TBM실시시간.eTime) {
          return "완료";
        }
      }
      return "미진행";
    },
    useConfinedSpaceWork() {
      return this.form.inspectChecked.includes("밀폐공간 작업");
    },
    // 안전한 데이터 접근을 위한 computed 속성들
    safetyManagerDongkook: {
      get() {
        if (!this.form || !this.form.안전관계자 || !this.form.안전관계자.동국제강) {
          // 안전관계자.동국제강이 없으면 초기화
          this.$set(this.form, "안전관계자", this.form.안전관계자 || {});
          this.$set(this.form.안전관계자, "동국제강", { id: "", name: "", phone: "" });
        }
        return this.form.안전관계자.동국제강;
      },
      set(value) {
        if (!this.form.안전관계자) {
          this.$set(this.form, "안전관계자", {});
        }
        this.$set(this.form.안전관계자, "동국제강", value);
      },
    },
    safetyManagerConfirmer: {
      get() {
        if (!this.form || !this.form.안전관계자 || !this.form.안전관계자.확인자) {
          // 안전관계자.확인자가 없으면 초기화
          this.$set(this.form, "안전관계자", this.form.안전관계자 || {});
          this.$set(this.form.안전관계자, "확인자", { id: "", name: "" });
        }
        return this.form.안전관계자.확인자;
      },
      set(value) {
        if (!this.form.안전관계자) {
          this.$set(this.form, "안전관계자", {});
        }
        this.$set(this.form.안전관계자, "확인자", value);
      },
    },
  },
  data() {
    return {
      직위옵션,
      steps: ["등록", "", "작업중", "작업완료", ""],
      busyUserList: [], // 이미 작업중인 사용자 목록
      restrictedUsers: [], // 출입제한 사용자 목록
      tbmList: [], // 현재 문서를 매칭한 TBM 문서 리스트 (830번 게시판)

      targetMemberList: [], // 조회해야하는 작업자내역 정보
      targetMemberListBackup: [], // 조회해야하는 작업자내역 정보 백업 (반복해서 불러오지 않기 위함)
      form: {
        stdInfo: {},
        users: [], // qr code 로 읽은 사용자 정보 { id: number, type?: string }
        photoList: [],
        photoList2: [],
        fileList: [],

        상태: "",
        작업허가: {},
        작업정보: {
          작업시작날짜: "",
          작업완료날짜: "",
          업체명: { id: 0, com_name: "" },
          작업구역: {},
          분류: "",
          작업내용: "",
        },
        CCTVs: [
          {
            이름: "",
            위치: "",
            설치방향: "",
            촬영범위: "",
          },
          {
            이름: "",
            위치: "",
            설치방향: "",
            촬영범위: "",
          },
        ],
        안전관계자: {
          동국제강: { id: "", name: "", phone: "" },
          공사업체: [{ id: "", name: "", phone: "" }],
          확인자유무: "n",
          확인자: {
            id: "",
            부서: "",
            소속: "",
            직책: "",
            성명: "",
            서명: "", // 새로 추가됨
          },
          확인자읽기전용: false,
          확인일시: "",
          확인자서명: { sign: "" },
        },

        inspectChecked: ["일반작업", "화기작업"],
        inspectList: [
          { id: 1, label: "일반작업", checked: false, list: inspectData.inspectTable_1 },
          { id: 2, label: "화기작업", checked: false, list: inspectData.inspectTable_2, subList: [] },
          { id: 3, label: "고소작업", checked: false, list: inspectData.inspectTable_3 },
          { id: 4, label: "중장비 작업", checked: false, list: inspectData.inspectTable_4 },
          { id: 5, label: "밀폐공간 작업", checked: false, list: inspectData.inspectTable_5, subList: [] },
          { id: 6, label: "정전(전기차단)작업", checked: false, list: inspectData.inspectTable_6 },
          { id: 7, label: "굴착작업", checked: false, list: inspectData.inspectTable_7 },
          { id: 8, label: "방사선 관련 작업", checked: false, list: inspectData.inspectTable_8 },
        ],
        작업자내역: [],
        DKS발주부서장확인서: {}, // 65세 이상 확인서 첨부
      },
      isSafetyManager: true,
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            if (key === "작업허가" && this.form[key]) {
              // 기존 승인 정보 백업
              let 작업승인_정보 = {};
              let 연장승인_정보 = {};
              let 작업종료_정보 = {};

              // 작업승인 정보 백업
              if (this.form[key].작업승인 && this.form[key].작업승인.승인자) {
                작업승인_정보 = {
                  승인자: JSON.parse(JSON.stringify(this.form[key].작업승인.승인자)),
                  승인일시: this.form[key].작업승인.승인일시,
                };
              }

              // 연장승인 정보 백업
              if (this.form[key].연장승인 && this.form[key].연장승인.승인자) {
                연장승인_정보 = {
                  승인자: JSON.parse(JSON.stringify(this.form[key].연장승인.승인자)),
                  승인일시: this.form[key].연장승인.승인일시,
                };
              }

              // 작업종료 정보 백업
              if (this.form[key].작업종료 && this.form[key].작업종료.승인자) {
                작업종료_정보 = {
                  승인자: JSON.parse(JSON.stringify(this.form[key].작업종료.승인자)),
                  승인일시: this.form[key].작업종료.승인일시,
                };
              }

              // 새 데이터로 업데이트
              this.form[key] = value[key];

              // 작업승인 정보 복원 (필요한 경우)
              if (작업승인_정보.승인일시 && 작업승인_정보.승인자) {
                if (!this.form[key].작업승인 || !this.form[key].작업승인.승인자 || Object.keys(this.form[key].작업승인.승인자).length === 0) {
                  // 승인자 정보가 없거나 비어있는 경우에만 복원
                  if (!this.form[key].작업승인) {
                    this.form[key].작업승인 = {};
                  }
                  this.form[key].작업승인.승인자 = 작업승인_정보.승인자;
                }
              }

              // 연장승인 정보 복원 (필요한 경우)
              if (연장승인_정보.승인일시 && 연장승인_정보.승인자) {
                if (!this.form[key].연장승인 || !this.form[key].연장승인.승인자 || Object.keys(this.form[key].연장승인.승인자).length === 0) {
                  if (!this.form[key].연장승인) {
                    this.form[key].연장승인 = {};
                  }
                  this.form[key].연장승인.승인자 = 연장승인_정보.승인자;
                }
              }

              // 작업종료 정보 복원 (필요한 경우)
              if (작업종료_정보.승인일시 && 작업종료_정보.승인자) {
                if (!this.form[key].작업종료 || !this.form[key].작업종료.승인자 || Object.keys(this.form[key].작업종료.승인자).length === 0) {
                  if (!this.form[key].작업종료) {
                    this.form[key].작업종료 = {};
                  }
                  this.form[key].작업종료.승인자 = 작업종료_정보.승인자;
                }
              }
            } else {
              this.form[key] = value[key];
            }
          }
        }

        this.form.상태 = this.statusNumber;
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value._etc = {
          구분: "",
          작업허가명: "",
          허가번호: value.작업정보.허가번호,
          관리감독자: value.안전관계자.동국제강,
          작업장소: value.작업정보.작업구역,
          작업내용: value.작업정보.작업내용,
        };

        this.$emit("input", value);
      },
    },
    "form.작업자내역": {
      deep: true,
      handler(value) {
        const target = [];

        // busyUserList 에 등록되어 있는 사용자는 작업자로 등록할 수 없다.
        for (let i = 0; i < value.length; i++) {
          if (this.busyUserList.includes(parseInt(`${value[i].userId}`))) {
            value[i].error = "이미 작업중인 사용자입니다.";
          } else if (this.restrictedUsers.includes(parseInt(`${value[i].userId}`))) {
            value[i].error = "출입이 제한된 사용자입니다.";
          } else {
            delete value[i].error;
          }

          target.push(value[i].userId);
        }

        this.targetMemberList = target;
        this.form.users = value.map((worker) => ({ id: worker.userId, type: "qr" }));
      },
    },
    targetMemberList: {
      deep: true,
      handler(value) {
        // 백업본과 비교하여 값이다르면 맴버정보를 서버에서 조회하여 업데이트한다.
        if (JSON.stringify(value) !== JSON.stringify(this.targetMemberListBackup)) {
          this.loadMemberListInfo(value);
          this.targetMemberListBackup = value;
        }
      },
    },
    postId(postId) {
      this.findTBL();
    },
  },
  created() {
    this.findTBL();

    // 현재 사용자가 관리감독자인지 확인한다
    this.checkSafetyManger();
  },
  methods: {
    formatPhone,
    clickPageTop() {
      const workPermitElement = document.getElementById("workPermit");
      if (workPermitElement) {
        const elementPosition = workPermitElement.getBoundingClientRect().top;

        // 현재 스크롤 위치가 workPermit 요소 근처인지 확인 (헤더 높이 + 여유 공간 고려)
        const isNearWorkPermit = Math.abs(elementPosition - 100) < 150;

        if (isNearWorkPermit) {
          // 이미 workPermit 근처에 있으면 최상단으로 스크롤
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        } else {
          // workPermit 요소로 스크롤 (100px 위로)
          const offsetPosition = elementPosition + window.pageYOffset - 100;
          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
          });
        }
      }
    },
    setErrorMsg() {
      let count = 0;

      // busyUserList 에 등록되어 있는 사용자는 작업자로 등록할 수 없다.
      const errBusy = "이미 작업중인 사용자입니다.";
      for (let i = 0; i < this.form.작업자내역.length; i++) {
        if (this.busyUserList.includes(parseInt(`${this.form.작업자내역[i].userId}`))) {
          if (!this.form.작업자내역[i].error) {
            this.form.작업자내역[i].error = errBusy;
            count++;
          }
        } else if (this.form.작업자내역[i].error === errBusy) {
          delete this.form.작업자내역[i].error;
        }
      }

      // busyUserList 에 등록되어 있는 사용자는 작업자로 등록할 수 없다.
      const errRes = "출입이 제한된 사용자입니다.";
      for (let i = 0; i < this.form.작업자내역.length; i++) {
        if (this.restrictedUsers.includes(parseInt(`${this.form.작업자내역[i].userId}`))) {
          if (!this.form.작업자내역[i].error) {
            this.form.작업자내역[i].error = errRes;
            count++;
          }
        } else if (this.form.작업자내역[i].error === errRes) {
          delete this.form.작업자내역[i].error;
        }
      }

      if (count) {
        this.form.작업자내역 = [...this.form.작업자내역];
      }
    },
    // 최종 저장 전 호출되는 함수, post = { header: {...}, body: {...} } 형식으로 반환해야 한다.
    async prevSaveEvent(post) {
      // 확인자를 선택 했을 경우, 수정 불가 상태로 저장
      if (post.body.안전관계자.확인일시) {
        post.body.안전관계자["확인자읽기전용"] = true;
      }
      return post;
    },
    async validate() {
      const 작업자Ids = this.form.작업자내역.map((worker) => worker.userId);
      const response = await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId: this.projectId,
        boardId: 1043,
        page: 1,
        perPage: Math.max(작업자Ids.length, 1),
        conditions: [
          { key: "body.작업자정보.작업자.id", operator: "IN", value: 작업자Ids },
          { key: "body.출입제한기간.sDate", operator: "<=n", value: `${new Date().format("yyyy-MM-dd")}` },
          { key: "body.출입제한기간.eDate", operator: ">=n", value: `${new Date().format("yyyy-MM-dd")}` },
        ],
      });
      const 검색된_출입제한_작업자_list = response.data;
      const 검색된_출입제한_작업자_ids = 검색된_출입제한_작업자_list
        .filter((item) => {
          const 제한사업장 = JSON.parse(item.post_content).body.제한사업장 || [];
          // 허가 신청자의 사업장명으로 비교함
          return 제한사업장.length === 0 || 제한사업장.includes("전사") || 제한사업장.includes(this.form.stdInfo.field_name);
        })
        .map((item) => {
          const body = JSON.parse(item.post_content).body;
          return body.작업자정보.작업자.id;
        });
      this.restrictedUsers = 검색된_출입제한_작업자_ids;
      this.setErrorMsg();

      if (검색된_출입제한_작업자_ids.length > 0) {
        return "<p style='font-size: 24px; font-weight: 500; text-align: center; margin-bottom: 1rem;'>출입이 제한된 인원이 있습니다.</p><p style='text-align: center;'>작업자 내역을 확인해주세요.</p>";
      }

      if (this.form.inspectList[1].checked === 1 || this.form.inspectList[1].checked === "1" || this.form.inspectList[1].checked === true) {
        if (!(this.form.inspectList[1].list[4].성명 || "").trim()) {
          return "화기작업 - 화재감시자 성명을 반드시 입력해야 합니다";
        }
      }

      // 밀폐공간 작업이 선택된 경우 가스 농도 확인 (문서 업데이트 시에만 검토)
      if (this.postId && this.statusNumber !== 0) {
        const 밀폐공간작업 = this.form.inspectList.find((inspect) => inspect.label === "밀폐공간 작업" && inspect.checked);
        if (밀폐공간작업 && 밀폐공간작업.subList && 밀폐공간작업.subList.length > 0) {
          for (const 가스농도목록 of 밀폐공간작업.subList) {
            const 산소값 = parseFloat(가스농도목록.산소);
            const 탄산가스값 = parseFloat(가스농도목록.탄산가스);
            const 일산화탄소값 = parseFloat(가스농도목록.일산화탄소);
            const 황화수소값 = parseFloat(가스농도목록.황화수소);

            // 값이 입력되지 않았거나 유효하지 않은 경우 체크
            if (isNaN(산소값) || isNaN(탄산가스값) || isNaN(일산화탄소값) || isNaN(황화수소값)) {
              return "<p style='font-size: 20px; font-weight: 500; text-align: center; margin-bottom: 1rem;'>가스 농도 측정값을 모두 입력해주세요.</p><p style='text-align: center;'>산소, 탄산가스, 일산화탄소, 황화수소 값을 입력해야 합니다.</p>";
            }

            // 산소(O2): 18% 이상 23.5% 미만
            if (산소값 < 18 || 산소값 >= 23.5) {
              return `<p style='font-size: 20px; font-weight: 500; text-align: center; margin-bottom: 1rem;'>산소 농도가 기준을 벗어났습니다.</p><p style='text-align: center;'>산소(O2) 농도는 18% 이상 23.5% 미만이어야 합니다.<br/>현재 측정값: ${산소값}%</p>`;
            }

            // 탄산가스(CO2): 1.5% 미만
            if (탄산가스값 >= 1.5) {
              return `<p style='font-size: 20px; font-weight: 500; text-align: center; margin-bottom: 1rem;'>탄산가스 농도가 기준을 벗어났습니다.</p><p style='text-align: center;'>탄산가스(CO2) 농도는 1.5% 미만이어야 합니다.<br/>현재 측정값: ${탄산가스값}%</p>`;
            }

            // 일산화탄소(CO): 30ppm 미만
            if (일산화탄소값 >= 30) {
              return `<p style='font-size: 20px; font-weight: 500; text-align: center; margin-bottom: 1rem;'>일산화탄소 농도가 기준을 벗어났습니다.</p><p style='text-align: center;'>일산화탄소(CO) 농도는 30ppm 미만이어야 합니다.<br/>현재 측정값: ${일산화탄소값}ppm</p>`;
            }

            // 황화수소(H2S): 10ppm 미만
            if (황화수소값 >= 10) {
              return `<p style='font-size: 20px; font-weight: 500; text-align: center; margin-bottom: 1rem;'>황화수소 농도가 기준을 벗어났습니다.</p><p style='text-align: center;'>황화수소(H2S) 농도는 10ppm 미만이어야 합니다.<br/>현재 측정값: ${황화수소값}ppm</p>`;
            }

            // 평가결과 확인
            if (가스농도목록.평가결과 === "부적합") {
              return "<p style='font-size: 20px; font-weight: 500; text-align: center; margin-bottom: 1rem;'>가스 농도가 기준을 벗어났습니다.</p><p style='text-align: center;'>모든 가스 농도가 기준값을 만족해야 합니다.<br/>평가결과: 부적합</p>";
            }
          }
        }
      }

      if (this.form.작업허가 && this.form.작업허가.작업승인 && this.form.작업허가.작업승인.상태 === "승인") {
        const 화기작업 = this.form.inspectList.find((inspect) => inspect.label === "화기작업" && inspect.checked);
        if (화기작업) {
          if (화기작업.subList.length === 0) {
            return "가스농도를 입력해주세요.";
          }
          for (const 가스농도목록 of 화기작업.subList) {
            if (!(가스농도목록.물질명 && 가스농도목록.결과 && 가스농도목록.측정시간 && 가스농도목록.측정자)) {
              return "가스농도를 입력해주세요.";
            }
          }
        }

        const 밀폐공간작업 = this.form.inspectList.find((inspect) => inspect.label === "밀폐공간 작업" && inspect.checked);
        if (밀폐공간작업) {
          if (밀폐공간작업.subList.length === 0) {
            return "가스농도를 입력해주세요.";
          }
          for (const 가스농도목록 of 밀폐공간작업.subList) {
            if (!(가스농도목록.산소 && 가스농도목록.탄산가스 && 가스농도목록.일산화탄소 && 가스농도목록.황화수소 && 가스농도목록.측정시간 && 가스농도목록.측정자)) {
              return "가스농도를 입력해주세요.";
            }
          }
        }

        const 정전작업 = this.form.inspectList.find((inspect) => inspect.label === "정전(전기차단)작업" && inspect.checked);
        if (정전작업) {
          const 전원차단 = { 차단자: 정전작업.list[6].차단자, 차단시간: 정전작업.list[6].차단시간 };
          if (!전원차단.차단자 || !전원차단.차단시간) {
            return "전원 차단자와 차단시간을 입력해주세요.";
          }
        }

        const photoList = this.form.photoList.filter((photo) => photo.id);
        if (photoList.length === 0) {
          return "작업 전 사진을 첨부해주세요.";
        }

        if (this.tbmStatus !== "완료") {
          return "TBM 작성을 완료해주세요.";
        }
      }

      if (this.form.작업허가 && this.form.작업허가.작업종료 && this.form.작업허가.작업종료.상태 === "승인") {
        const photoList2 = this.form.photoList2.filter((photo) => photo.id);
        if (photoList2.length === 0) {
          return "작업 후 사진을 첨부해주세요.";
        }

        const 정전작업 = this.form.inspectList.find((inspect) => inspect.label === "정전(전기차단)작업" && inspect.checked);
        if (정전작업) {
          const 전원복구 = { 차단자: 정전작업.list[7].복구자, 차단시간: 정전작업.list[7].복구시간 };
          if (!전원복구.차단자 || !전원복구.차단시간) {
            return "전원 복구자와 복구시간을 입력해주세요.";
          }
        }

        if (this.tbmStatus !== "완료") {
          return "TBM 작성을 완료해주세요.";
        }
      }
    },
    async findTBL() {
      // TBM 정보를 불러온다.
      if (this.postId) {
        const conditions = [];
        conditions.push({ key: "body.TBM정보.postId", operator: "=", value: this.postId });
        const res = await this.$store.dispatch("board/LOAD_POST_LIST", {
          projectId: this.projectId,
          boardId: 830,
          page: 1,
          perPage: 10,
          orderTarget: "created_at",
          orderDirection: "desc",
          conditions,
        });

        this.tbmList = res && res.data && res.data.length > 0 ? res.data : [];

        // 작성페이지의 상단 버튼들을 다시 그릴 수 있도록 이벤트를 발생시킨다.
        const event = new CustomEvent("refreshButtons");
        window.dispatchEvent(event);
      }
    },

    // 작업허가서에 등록되어 있는 작업자 중 현재 작업시간에 작업이 불가능한 작업자를 찾는다.
    async findBusyUserList() {
      if (!(this.form.작업허가.작업시작일시 && this.form.작업허가.작업시간.시작 && this.form.작업허가.작업시간.종료)) {
        return;
      }

      const conditions = [];
      // 작업시작일시가 오늘인 게시글을 불러온다
      const today = new Date(this.form.작업허가.작업시작일시);
      conditions.push({ key: "body.작업허가.작업시작일시", operator: ">=", value: today.format("yyyy-MM-dd") });
      conditions.push({ key: "body.작업허가.작업시작일시", operator: "<", value: today.addDays(1).format("yyyy-MM-dd") });
      // 작업시간이 겹친 게시글을 불러온다.
      conditions.push({ key: "body.작업허가.작업시간.시작", operator: "<", value: this.form.작업허가.작업시간.종료 });
      conditions.push({ key: "body.작업허가.작업시간.종료", operator: ">", value: this.form.작업허가.작업시간.시작 });

      const options = {
        projectId: this.projectId,
        postId: this.postId,
        page: 1,
        perPage: 50,
        conditions,
      };
      // 976 외부공사·작업
      // 981 내부작업(직영)
      // 979 일 장비사용계획서
      this.loading(true);
      const list976 = await this._loadDefragmentation({ ...options, boardId: 976 });
      const list981 = await this._loadDefragmentation({ ...options, boardId: 981 });
      const list979 = await this._loadDefragmentation({ ...options, boardId: 979 });
      this.loading(false);

      const userIds = [];
      for (let i = 0; i < list976.length; i++) {
        const body = JSON.parse(list976[i].post_content).body;
        userIds.push(...body.작업자내역.map((worker) => worker.userId));
      }
      for (let i = 0; i < list981.length; i++) {
        const body = JSON.parse(list981[i].post_content).body;
        userIds.push(...body.작업자내역.map((worker) => worker.userId));
      }
      for (let i = 0; i < list979.length; i++) {
        const body = JSON.parse(list979[i].post_content).body;
        userIds.push(...body.운전자정보.map((worker) => worker.userId));
      }

      this.busyUserList = [...new Set(userIds)];
      this.setErrorMsg();
    },
    async _loadDefragmentation(options) {
      const response = await this.$store.dispatch("board/LOAD_POST_LIST", options);
      const list = [];
      for (let i = 0; i < response.data.length; i++) {
        // 현재 게시글은 제외한다.
        if (response.data[i].id === options.postId) {
          continue;
        }
        list.push(response.data[i]);
      }
      if (response.current_page !== response.last_page) {
        options.page = response.current_page + 1;
        list.push(...(await this._loadDefragmentation(options)));
      }
      return list;
    },
    loading(open) {
      const loadingDialog = new CustomEvent("loadingDialog", {
        detail: {
          open,
        },
      });
      window.dispatchEvent(loadingDialog);
    },

    refreshQrList() {
      if (this.boardId && this.postId) {
        this.$store
          .dispatch("board/LOAD_POST", {
            boardId: this.boardId,
            postId: this.postId,
          })
          .then((post) => {
            this.post.qr_reads = post.qr_reads;
          });
      }
    },
    checkedTitle(list) {
      this.form.inspectChecked = list;
    },

    // 생년월일을 입력받아 만 나이를 계산하여 65세 이상인지 확인
    isSeniorCitizen(생년월일) {
      const currentYear = new Date().getFullYear();
      const currentCentury = Math.floor(currentYear / 100) * 100; // 현재 세기의 시작 (예: 2000, 1900)
      let birthYear = parseInt(생년월일.substring(0, 2), 10);
      birthYear += birthYear <= currentYear % 100 ? currentCentury : currentCentury - 100;
      const age = currentYear - birthYear - 1;
      return age >= 65;
    },

    onSelectMember(member, selectedMember) {
      const keys = Object.keys(selectedMember);
      for (const key of keys) {
        member[key] = selectedMember[key];
      }
    },

    onSelectWorkPermit(type, status) {
      if (type === "작업승인" && status === "승인") {
        // 화기작업을 선택 했을 경우, 가스농도 측정결과(화기작업) 비고를 제외한 나머지를 필수 입력
        const 화기작업 = this.form.inspectList.find((inspect) => inspect.label === "화기작업" && inspect.checked);
        if (화기작업) {
          if (화기작업.subList.length === 0) {
            return {
              error: "가스농도를 입력해주세요.",
            };
          }

          for (const 가스농도목록 of 화기작업.subList) {
            if (!(가스농도목록.물질명 && 가스농도목록.결과 && 가스농도목록.측정시간 && 가스농도목록.측정자)) {
              return {
                error: "가스농도를 입력해주세요.",
              };
            }
          }
        }
        // 밀폐공간작업을 선택 했을 경우, 가스농도 측정결과(밀폐공간) 비고를 제외한 나머지를 필수 입력
        const 밀폐공간작업 = this.form.inspectList.find((inspect) => inspect.label === "밀폐공간 작업" && inspect.checked);
        if (밀폐공간작업) {
          if (밀폐공간작업.subList.length === 0) {
            return {
              error: "가스농도를 입력해주세요.",
            };
          }

          for (const 가스농도목록 of 밀폐공간작업.subList) {
            if (!(가스농도목록.산소 && 가스농도목록.탄산가스 && 가스농도목록.일산화탄소 && 가스농도목록.황화수소 && 가스농도목록.측정시간 && 가스농도목록.측정자)) {
              return {
                error: "가스농도를 입력해주세요.",
              };
            }
          }
        }

        // 정전(전기차단)작업을 선택 했을 경우, 차단기와 관련된 데이터 필수 입력
        const 정전작업 = this.form.inspectList.find((inspect) => inspect.label === "정전(전기차단)작업" && inspect.checked);
        if (정전작업) {
          const 차단기번호 = 정전작업.list[1].차단기번호;
          const 전원차단 = { 차단자: 정전작업.list[6].차단자, 차단시간: 정전작업.list[6].차단시간 };
          const 전원복구 = { 차단자: 정전작업.list[7].복구자, 차단시간: 정전작업.list[7].복구시간 };

          if (!전원차단.차단자 || !전원차단.차단시간) {
            return {
              error: "전원 차단자와 차단시간을 입력해주세요.",
            };
          }
        }

        // photoList 에 사진을 첨부해야 한다.
        const photoList = this.form.photoList.filter((photo) => photo.id);
        if (photoList.length === 0) {
          return {
            error: "작업 전 사진을 첨부해주세요.",
          };
        }

        // TBM 진행 상태가 완료여야 한다.
        if (this.tbmStatus !== "완료") {
          // TBM 페이지로 이동에 필요한 데이터
          // const projectId = this.tbmList[0].project_id;
          // const boardId = this.tbmList[0].board_id;
          // const postId = this.tbmList[0].id;
          return {
            error: "TBM 작성을 완료해주세요.",
          };
        }
      }

      if (type === "작업종료" && status === "승인") {
        // photoList2 에 사진을 첨부해야 한다.
        const photoList2 = this.form.photoList2.filter((photo) => photo.id);
        if (photoList2.length === 0) {
          return {
            error: "작업 후 사진을 첨부해주세요.",
          };
        }

        // 정전(전기차단)작업을 선택 했을 경우, 차단기와 관련된 데이터 필수 입력
        const 정전작업 = this.form.inspectList.find((inspect) => inspect.label === "정전(전기차단)작업" && inspect.checked);
        if (정전작업) {
          const 차단기번호 = 정전작업.list[1].차단기번호;
          const 전원차단 = { 차단자: 정전작업.list[6].차단자, 차단시간: 정전작업.list[6].차단시간 };
          const 전원복구 = { 차단자: 정전작업.list[7].복구자, 차단시간: 정전작업.list[7].복구시간 };

          if (!전원복구.차단자 || !전원복구.차단시간) {
            return {
              error: "전원 복구자와 복구시간을 입력해주세요.",
            };
          }
        }

        // TBM 진행 상태가 완료여야 한다.
        if (this.tbmStatus !== "완료") {
          // TBM 페이지로 이동에 필요한 데이터
          // const projectId = this.tbmList[0].project_id;
          // const boardId = this.tbmList[0].board_id;
          // const postId = this.tbmList[0].id;
          return {
            error: "TBM 작성을 완료해주세요.",
          };
        }
      }

      return true;
    },

    // 복사하기 기능을 사용하여, 복사된 게시글의 내용을 수정할 때 호출
    // (URL query 에 _cp_pid 가 있을 경우 호출)
    // watch 로 처리하지 않은 이유는, watch 로 처리하면, 필요 없는 데이터를 초기화 하는 과정에서 불필요하게 화면을 갱신하기 때문 (무한반복하는 경우도 있음)
    cpPostContent(contents) {
      const body = contents.body;

      // 복사 제외 처리
      if (body) {
        // stdInfo 제외
        if (body.stdInfo) delete body.stdInfo;

        // 작업허가 - 대기상태로 변경
        if (body.작업허가) {
          body.작업허가 = {
            작업시작일시: body.작업허가.작업시작일시,
            작업종료일시: body.작업허가.작업종료일시,
            연장종료일시: "",
            작업시간: {
              시작: body.작업허가.작업시간.시작,
              종료: body.작업허가.작업시간.종료,
              연장: "",
              error: "",
            },
            작업승인: {
              상태: "대기",
              승인자: {
                부서: "",
                소속: "",
                직책: "",
                성명: "",
                서명: { sign: "" },
              },
              승인일시: "",
              error: "",
            },
            연장승인: {
              상태: "없음",
              승인자: {
                부서: "",
                소속: "",
                직책: "",
                성명: "",
                서명: { sign: "" },
              },
              승인일시: "",
              error: "",
            },
            작업종료: {
              상태: "대기",
              승인자: {
                부서: "",
                소속: "",
                직책: "",
                성명: "",
                서명: { sign: "" },
              },
              승인일시: "",
              error: "",
            },
          };
        }

        // 안전관계자
        if (body.안전관계자) {
          body.안전관계자 = {
            확인자유무: "n",
            확인자: {
              id: "",
              부서: "",
              소속: "",
              직책: "",
              성명: "",
              서명: "", // 새로 추가됨
            },
            확인자읽기전용: false,
            확인일시: "",
          };
        }

        // 작업유형
        if (body.inspectList && body.inspectList.length > 0) {
          for (const inspect of body.inspectList) {
            if (inspect.list && inspect.list.length > 0) {
              for (const item of inspect.list) {
                if (item.isChecked && item.isChecked.length > 0) {
                  if (item.isChecked.indexOf("신청자") > -1) {
                    item.isChecked = ["신청자"];
                  } else {
                    item.isChecked = [];
                  }
                }
              }
            }
          }
        }

        // 작업 전/후 사진
        if (body.photoList) delete body.photoList;
        if (body.photoList2) delete body.photoList2;
      }

      contents.body = {
        ...this.form,
        ...body,
      };
      return contents;
    },

    onClickTBM() {
      if (this.tbmList && this.tbmList.length > 0) {
        const post = this.tbmList[0];
        const popup = window.open(`/project/${post.project_id}/tab/${post.board_id}/write/${post.id}`, "_blank", `width=${screen.width},height=${screen.height}`);
      }
    },

    onChangeSafetyManagerConfirmer(value) {
      if (value === "y") {
        const id = this.board.writer.id || this.myInfo.id || 0;
        const 부서 = this.board.writer.section || this.myInfo.section || this.board.writer.department || this.myInfo.department || "-";
        const 소속 = this.board.writer.department || this.myInfo.department || this.board.writer.section || this.myInfo.section || "-";
        const 직책 = this.board.writer.rank || this.myInfo.rank || "-";
        const 성명 = this.board.writer.name || this.myInfo.name || "-";
        const 서명 = this.board.writer.서명 || this.myInfo.서명 || { sign: "" };

        this.form.안전관계자.확인자 = { id, 부서, 소속, 직책, 성명, 서명 };
        this.form.안전관계자.확인일시 = new Date().format("yyyy-MM-dd, HH:mm");
      } else {
        this.form.안전관계자.확인자 = { id: 0, 부서: "", 소속: "", 직책: "", 성명: "", 서명: "" };
        this.form.안전관계자.확인일시 = "";
      }
    },

    // 상단 버튼 설정
    setNormalBoardButtons(template) {
      const tbm = {
        shouldShow: { mode: "u", freePass: 1, permission: "u", onlyWriter: false },
        component: "div",
        props: { class: ["hidden", "xl:flex", "h-full"] },
        content: `<div class="flex items-center gap-2 ${this.tbmStatus === "완료" && "cursor-pointer"}" style="font-weight: 500;">TBM 여부 : ${this.htmlComponent[this.tbmStatus]}</div>`,
        emits: {
          click: (func) => {
            this.onClickTBM();
          },
        },
      };

      const saveFunc = template.save.emits.click;
      template.save.shouldShow.onlyWriter = false;
      template.save.emits.click = (func) => {
        if (!this.form.stdInfo.field_id) {
          this.$vs.notify({
            title: "사업장명 선택",
            text: "허가 신청자의 사업장명을 선택해주세요.",
            color: "danger",
            position: "top-right",
          });
          return;
        }

        // 2026-05-22: 내부작업(사내수급) 문서(986)에서는 발주부서장 확인서 검증을 생략 요청에 따라 비활성화
        // if (this.showSpecialAttachment) {
        //   // 확인서 첨부가 있는지 확인
        //   if (!this.form.DKS발주부서장확인서
        //     || !this.form.DKS발주부서장확인서.path
        //     || Object.keys(this.form.DKS발주부서장확인서).length === 0) {
        //     this.$vs.notify({
        //       title: "확인서 첨부",
        //       text: "만 65세 이상 인원 또는 외국인 인원이 있습니다.<br>확인서를 첨부해주세요.",
        //       color: "danger",
        //       position: "top-right",
        //     });
        //     return;
        //   }
        // }

        // form.inspectList
        if (this.postId) {
          for (let i = 0; i < this.form.inspectList.length; i++) {
            const inspect = this.form.inspectList[i];
            if (inspect.checked) {
              const list = inspect.list;
              const has허가자 = list.some((item) => item.isChecked.includes("허가자"));
              for (const item of list) {
                // 허가자가 한개라도 체크되어 있는 경우,
                // 신청자가 체크된 항목은 모두 허가자도 체크되어 있어야 한다.
                if (has허가자) {
                  if (item.isChecked.includes("신청자") && !item.isChecked.includes("허가자")) {
                    this.$vs.notify({
                      title: "검사 오류",
                      text: "점검사항의 허가자를 체크해주세요.",
                      color: "danger",
                      position: "top-right",
                    });
                    return;
                  }
                }

                // 연장상태인 경우, 연장허가자도 체크되어 있어야 한다.
                if (this.form.작업허가.연장승인.상태 === "승인") {
                  if ((item.isChecked.includes("신청자") || item.isChecked.includes("허가자")) && !item.isChecked.includes("연장허가")) {
                    this.$vs.notify({
                      title: "검사 오류",
                      text: "점검사항의 연장허가를 체크해주세요.",
                      color: "danger",
                      position: "top-right",
                    });
                    return;
                  }
                }
              }
            }
          }
        }

        // form.작업자내역
        const 직위옵션 = this.직위옵션; // 979
        for (let i = 0; i < this.form.작업자내역.length; i++) {
          const worker = this.form.작업자내역[i];

          if (!직위옵션.includes(worker.직위)) {
            this.$vs.notify({
              title: "작업자 오류",
              text: "작업자의 직위를 선택해주세요.",
              color: "danger",
              position: "top-right",
            });
            return;
          }

          if (this.useConfinedSpaceWork && worker.밀폐공간안전교육만료일자error) {
            this.$vs.notify({
              title: "작업자 오류",
              text: "밀폐공간안전교육을 수강하지 않았거나, 밀폐공간안전교육 기간이 만료된 작업자가 있습니다.",
              color: "danger",
              position: "top-right",
            });
            return;
          }

          if (worker.error) {
            this.$vs.notify({
              title: "작업자 오류",
              text: "이미 작업중인 사용자가 있습니다.",
              color: "danger",
              position: "top-right",
            });
            return;
          }
        }

        // 저장
        saveFunc(func);
      };
      return [tbm, template.print, template.delete, template.move, template.save, template.copy];
    },

    /**
     * 현재 사용자가 안전보건관리자로 지정되어 있는지 확인한다
     */
    async checkSafetyManger() {
      const boardIds = [738, 996, 997, 998, 999, 1000, 1038];
      const fields = ["body.관리감독자정보.사번", "body.subInfo.사번"];
      const response = await this.$store.dispatch("board/CHECK_SAFETY_MANAGER", {
        boardIds,
        fields,
      });

      if (response) {
        this.isSafetyManager = response.isSafetyManager || false;
        return response.isSafetyManager || false;
      }
      return false;
    },

    transformToMeta(metas) {
      const meta = {};

      metas.forEach(({ meta_key, meta_value }) => {
        const keys = meta_key.split(".");
        let current = meta;

        // Traverse or create nested objects
        keys.forEach((key, index) => {
          if (index === keys.length - 1) {
            // Check if value is numeric and convert
            current[key] = /^\d+$/.test(meta_value) ? Number(meta_value) : meta_value;
          } else {
            if (!current[key]) {
              current[key] = {}; // Create a new object if not exists
            }
            current = current[key];
          }
        });
      });

      return meta;
    },

    async loadMemberListInfo(userIds) {
      await HttpRequest.get("/api/v1/member", {
        params: {
          projectId: this.$route.params.proj_id,
          userIds,
          page: 1,
          perPage: 10000,
        },
      })
        .then((response) => {
          const userIdToMetasMap = new Map();
          const userIdToDatasMap = new Map();
          for (const item of response.data) {
            if (item.metas.length > 0) {
              userIdToMetasMap.set(item.id, this.transformToMeta(item.metas));
            }

            const mobile = item.mobile !== "" ? item.mobile : item.phone;
            const rank = item.rank ? item.rank : "";
            userIdToDatasMap.set(item.id, {
              mobile,
              rank,
            });
          }

          for (const member of this.form.작업자내역) {
            if (userIdToMetasMap.has(member.userId)) {
              const metas = userIdToMetasMap.get(member.userId);

              const 생년월일 = metas.rrn ? `${metas.rrn}`.padStart(7, "0").slice(0, -1) : "";
              member.생년월일 = member.생년월일 && member.생년월일 !== "" ? member.생년월일 : 생년월일;
              // const 외국인여부 = metas.is_foreigner && metas.is_foreigner !== "0" ? "외국인" : "내국인";
              // member.is_foreigner = 외국인여부;
            }

            if (userIdToDatasMap.has(member.userId)) {
              const data = userIdToDatasMap.get(member.userId);

              const 연락처 = member.연락처 && member.연락처 !== "" ? member.연락처 : data.mobile;
              if (연락처 !== "") {
                member.연락처 = 연락처.includes("-") ? 연락처 : 연락처.replace(/(\d{3})(\d{3,4})(\d{4})/, "$1-$2-$3");
              }
              // 직위는 회원가입시 입력하는 직책과 다를 수 있어서 값을 받아오지 않음
              // member.직위 = member.직위 && member.직위 !== "" ? member.직위 : data.rank
            }
          }
        })
        .catch(() => {});
    },
  },
};
</script>
